export default "/fonts/vendor/lightgallery.js/dist/lg.svg?adb7aeef16adb8599e2d261b9a3a9f1e";